import clsx from 'clsx'
import {FC} from 'react'
import {Row} from 'react-table'
import { IVerification } from '../../../interfaces/IVerification'

type Props = {
  row: Row<IVerification>
}

const CustomRow: FC<Props> = ({row}) => {
  const onRowClick = (item: any) => {
    //navigate(`/customers/person/${item.original.id}`);
  }
  let empty: any

  return (
  <tr {...row.getRowProps({row, onClick: () => onRowClick(row), ...empty})}>
    {row.cells.map((cell) => {
      return (
        <td
          {...cell.getCellProps()}
        >
          {cell.render('Cell')}
        </td>
      )
    })}
  </tr>
  )
}

export {CustomRow}
